import React from 'react';
import { HERO_BUNDLE_IMAGE } from '../data/config';
import { BONUSES } from '../data/content';

// Shows the real bundle image when HERO_BUNDLE_IMAGE is set; otherwise a coded mockup.
export function BundleMockup({
  compact = false
}: {
  compact?: boolean;
}) {
  if (HERO_BUNDLE_IMAGE) {
    return <img src={HERO_BUNDLE_IMAGE} alt="120+ Done-For-You Templates for Therapists™ with 4 free bonuses" className={`mx-auto block h-auto w-full ${compact ? 'max-w-md' : 'max-w-xl'}`} data-id="element-189" data-mp="3clg9o9xb3j4i" />;
  }
  return <div className={`relative mx-auto w-full ${compact ? 'max-w-xs' : 'max-w-sm'} px-2 pb-4 pt-2`} data-id="element-190" data-mp="33n4ia5om8hb0">
      <div className="relative mx-auto w-[64%] rounded-2xl bg-white p-2 shadow-2xl" data-id="element-191" data-mp="2oq3rq5i5use4">
        <div className="bg-sagegrad relative overflow-hidden rounded-xl p-3 text-white" data-id="element-192" data-mp="2to5diy6z15ta">
          <p className="text-[9px] font-semibold tracking-[0.2em] text-white/80" data-id="element-193" data-mp="mxz1qzk82561">SIGMA SMART™</p>
          <p className="font-display mt-5 text-4xl font-extrabold leading-none text-terra" data-id="element-194" data-mp="ruxxfmjjak6c">120+</p>
          <p className="font-display text-lg font-bold leading-tight" data-id="element-195" data-mp="qcivzu5plhle">DONE-FOR-YOU</p>
          <p className="font-display text-lg font-bold leading-tight" data-id="element-196" data-mp="lf96yfm8f7y3">TEMPLATES FOR</p>
          <p className="font-display text-lg font-bold leading-tight" data-id="element-197" data-mp="103vn2jjoo3qd">THERAPISTS™</p>
          <div className="mt-3 h-[6px] rounded bg-terra" data-id="element-198" data-mp="v4aq2eo2q5ga" />
          <p className="mt-2 text-[9px] text-white/80" data-id="element-199" data-mp="v4sp1j24exrw">126 TEMPLATES · WORD + PDF</p>
        </div>
      </div>
      <div className="mt-[-22px] grid grid-cols-4 gap-1.5" data-id="element-200" data-mp="7eydd4tjff98">
        {BONUSES.map((b, i) => <div key={b.title} className="min-w-0 rounded-lg bg-white p-1 shadow-md" style={{
        transform: `rotate(${[-4, -1, 2, 5][i]}deg)`
      }} data-id="element-201" data-mp="2hg2v9zvgrz4" data-mpi={i}>
            <div className="flex h-10 items-center justify-center rounded bg-sage font-display text-sm font-bold text-cream" data-id="element-202" data-mp="ce1dqbykoxav">B{i + 1}</div>
            <p className="mt-1 truncate text-center text-[7px] font-semibold" data-id="element-203" data-mp="1rt8llz3ne7ei">BONUS {i + 1}</p>
          </div>)}
      </div>
    </div>;
}

// Shows the real bonus cover when set; otherwise a coded cover.
export function BonusCover({
  index,
  image,
  short
}: {
  index: number;
  image: string;
  short: string;
}) {
  if (image) {
    return <img src={image} alt={`Bonus ${index + 1}`} className="mx-auto block h-auto w-full max-w-[180px]" loading="lazy" data-id="element-204" data-mp="piyj0pvufr0n" />;
  }
  return <div className="mx-auto w-full max-w-[150px] rounded-xl bg-white p-1.5 shadow-lg" data-id="element-205" data-mp="yi3f7pjxn89n">
      <div className="bg-sagegrad flex aspect-[3/4] flex-col justify-between rounded-lg p-2.5 text-white" data-id="element-206" data-mp="1s2tjzev17wk">
        <p className="text-[8px] tracking-[0.18em] text-white/75" data-id="element-207" data-mp="6pulgtfi8u0r">SIGMA SMART™</p>
        <div data-id="element-208" data-mp="ashg123k8t1n">
          <p className="font-display text-3xl font-extrabold leading-none text-terra" data-id="element-209" data-mp="arzcdkekjcjp">B{index + 1}</p>
          <p className="font-display mt-1 text-sm font-bold leading-tight" data-id="element-210" data-mp="fj7lsgfwexwv">{short}</p>
        </div>
        <div className="h-[5px] rounded bg-terra" data-id="element-211" data-mp="3f78xb03z5sgq" />
      </div>
    </div>;
}